import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";
import {NewsApiModel} from "./news.api-model";
import {NewsSourceApiModel} from "./news-source.api-model";

export class NewsResponseApiModel extends BaseApiResponseModel {
  news: Array<NewsApiModel>;
  NewsSources: Array<NewsSourceApiModel>;
  forceUpdateOnBackground: boolean


  constructor(model: NewsResponseApiModel, request: BaseApiRequestModel) {
    super(model, request);

    this.news = model?.news;
    this.newsSources = model?.newsSources;
    this.forceUpdateOnBackground = true;
  }
}
